import React from 'react'
import Datatable3 from '../../table/datatable3'

const DistributorList = ({getAllDistributor,totalPage,currentPage,setCurrentPage,buttonOptions,distributorDetails}) => {
  const columns = [
    { id: 'name', header: ' Name' },
    { id: 'user_email', header: 'Email' },
    { id: 'mobile_number', header: 'Phone No' },
    // { id: 'scheme', header: 'Scheme' },
    // { id: 'class', header: 'Class' },
  ];
  return (
    <>
    <Datatable3 getAllDistributor={getAllDistributor} totalPage={totalPage} currentPage={currentPage} setCurrentPage={setCurrentPage} buttonOptions={buttonOptions} data={distributorDetails} columns={columns} user_type="distributor" />
    </>
  )
}

export default DistributorList
